(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen-banners/assets/javascripts/banners.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen-banners/assets/javascripts/banners.js');

'use strict';

const _excluded = ["chances", "isSubscription", "endDate", "classNames"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const createBanner = (template, data) => {
  const bannerEl = document.createElement('div');
  $(bannerEl).append(template(data));
  return bannerEl;
};

const rowBanner = _ref => {
  let {
      chances,
      isSubscription,
      endDate,
      classNames = []
    } = _ref,
    options = _objectWithoutProperties(_ref, _excluded);
  const banner = new svs.numbergames.andra_chansen_banners.AndraChansenRow(_objectSpread(_objectSpread({}, options), {}, {
    chances,
    isSubscription,
    endDate,
    classNames
  }));
  return {
    render: () => {
      const el = document.createDocumentFragment();
      el.appendChild(banner.render());
      return el;
    },
    update: updatedOptions => {
      banner.update(updatedOptions);
    }
  };
};


const infoBanner = _ref2 => {
  let {
    draw,
    showBannerDateSmartness,
    options = {}
  } = _ref2;
  if (!draw) return;
  if (options !== null && options !== void 0 && options.dateSmartness && !showBannerDateSmartness) return;
  const data = _objectSpread({
    endDate: draw.endDate
  }, options);
  return createBanner(svs.numbergames.andra_chansen_banners.templates.info_banner, data);
};

const noWinBanner = _ref3 => {
  let {
    isInCurrentPeriod,
    andraChansenDraw,
    chancesPerLottoDraw
  } = _ref3;
  if (!chancesPerLottoDraw) return;
  const data = {
    chances: chancesPerLottoDraw,
    endDate: andraChansenDraw === null || andraChansenDraw === void 0 ? void 0 : andraChansenDraw.endDate,
    drawnum: andraChansenDraw === null || andraChansenDraw === void 0 ? void 0 : andraChansenDraw.drawNumber,
    isInCurrentPeriod
  };
  return createBanner(svs.numbergames.andra_chansen_banners.templates.no_win_banner, data);
};
const banners = {
  infoBanner,
  noWinBanner,
  rowBanner
};
Object.assign(svs.numbergames.andra_chansen_banners, banners);

 })(window);